module.exports = __webpack_public_path__ + "static/kz-7dc54aa2d495163ec3f3eba5d7573abc.svg";